import React from 'react';
import HowItWorks from './components/HowItWorks';
import SignUpSection from './components/SignUpSection';
import { motion } from "framer-motion";
import './LandingPage.css';

const LandingPage = () => {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="landing-container">
      {/* Hero Section */}
<section className="hero-v2">
  <motion.img
    src="/assets/icon_transparent.png"
    alt="Panacea Logo"
    className="hero-logo"
    initial={{ opacity: 0, y: -12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, ease: "easeOut" }}
  />

  <motion.h1
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.15, duration: 0.8, ease: "easeOut" }}
  >
    Precision Monitoring for<br/>Mental Health
  </motion.h1>

  <motion.p
    className="hero-subtext"
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.3, duration: 0.9, ease: "easeOut" }}
  >
    Panacea illuminates how psychiatric medications affect patients between visits — 
    revealing the early signals clinicians need to fine-tune dosages and prescriptions 
    before symptoms intensify.
  </motion.p>

  <motion.div
    className="hero-cta-row"
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.45, duration: 0.7 }}
  >
    <button
      className="hero-btn-primary glass-btn"
      onClick={() => scrollToSection("how-it-works-section")}
    >
      How It Works
    </button>

    <button
      className="hero-btn-secondary glass-outline-btn"
      onClick={() => scrollToSection("signup-section")}
    >
      Sign Up
    </button>
  </motion.div>
</section>

      {/* How It Works Section */}
      <section id="how-it-works-section" className="section how-it-works-section">
        <HowItWorks />
      </section>

      {/* Sign Up Section */}
      <section id="signup-section" className="signup-section">
        <SignUpSection />
      </section>
    </div>
  );
};

export default LandingPage;
